import Content from '../../content.js';
import DataTables from '../../components/dataTables';

namespace('IO.Views.Imports', function (exports) {
  'use strict';

  var Index = Content.extend({
    dom: {
      CURRENT_TABLE: '.ui.tab.active table',
      FIRST_TAB: '.ui.tab[data-tab="section0"]',
      TAB: '.rpm-menu .item',
      LOCATION_OUTPUT: '.location-output',
    },

    subscriptionId: null,

    _buildWebsocketChannel: function () {
      return '/imports';
    },

    _listen: function () {
      if (this.subscriptionId) {
        return;
      }
      this.subscriptionId = Messenger.on(
        this._buildWebsocketChannel(),
        this._updateImportsTable.bind(this),
      );
    },

    _stopListening: function () {
      if (!this.subscriptionId) {
        return;
      }
      Messenger.off(this._buildWebsocketChannel(), this.subscriptionId);
      this.subscriptionId = null;
    },

    _updateImportsTable: function (data) {
      var importTableSelector = '.importing-progress',
        myTarget,
        table,
        oTable,
        jobTable;

      if (data.tracker === true) {
        myTarget = $(importTableSelector);
        if (myTarget.html() === undefined) {
          myTarget = $(
            'table.' +
              data.resource +
              "-imports tbody tr:first td:contains('importing'), " +
              'table.' +
              data.resource +
              "-imports tbody tr:first td:contains('processing'), " +
              'table.' +
              data.resource +
              "-imports tbody tr:first td:contains('complete')",
          ).addClass(importTableSelector);
        }

        myTarget.html(data.progress + '% complete');
      } else {
        jobTable = data.import_table == 'location_imports';
        importTableSelector = data.import_table.replace(/_/g, '-');

        $.ajax({
          url: '/' + currentCustomer + '/' + data.import_table + '.json',
        }).done(function () {
          table = $('table.display.' + importTableSelector);
          if (!table.is(':visible')) {
            return;
          }
          oTable = table.dataTable({
            columns: jobTable
              ? window.da_grid_columns_jobs
              : window.da_grid_columns,
          });
          oTable.fnDraw();
        });
      }
    },

    events: function () {
      var events = {};

      events['click ' + this.dom.TAB] = '_lazyDrawDatatable';
      events['click ' + this.dom.LOCATION_OUTPUT] = '_toogleOutput';

      return events;
    },

    beforeRender: function () {
      this.tabs = [];
      this.dataTables = [];
    },

    render: function () {
      this._lazyDrawDatatable(undefined, this.dom.FIRST_TAB);
      this._listen();
    },

    onDestroy: function () {
      this._stopListening();
      _.each(this.dataTables, function (dataTable) {
        dataTable.remove();
      });
    },

    _isDataTableInstantiated: function ($table, tab) {
      return !($table.length && this.tabs.indexOf(tab) === -1);
    },

    _toogleOutput: function (e) {
      let target = $(e.target).parent('.location-output'),
        row;

      e.preventDefault();
      if (target.hasClass('opened')) {
        target.removeClass('opened');
        target.html('<i class="fa fa-angle-down"></i> <span>Show</span>');
        target.parents('tr').next('.virtual').remove();
      } else {
        target.addClass('opened');
        target.html('<i class="fa fa-angle-up"></i> <span>Hide</span>');
        row = $(
          `<tr class="virtual"><td colspan="6">${target.next('.content').html()}</td></tr>`,
        );
        row.insertAfter(target.parents('tr'));
      }
    },

    _lazyDrawDatatable: function (e, tab) {
      var $table, dataTable, jobTable;

      if (typeof tab === 'undefined') {
        tab = $(e.target).data('tab');
      }

      $table = this.$(this.dom.CURRENT_TABLE);
      jobTable = $table[0].id == 'imports-table-jobs';

      if (!this._isDataTableInstantiated($table, tab)) {
        dataTable = new DataTables({
          serverSide: true,
          el: $table,
          columns: jobTable
            ? window.da_grid_columns_jobs
            : window.da_grid_columns,
          filter: true,
          fixed: false,
          ajaxSource: $table.data('source'),
          sorting: [[0, 'desc']],
          aoColumnDefs: jobTable
            ? [
                {
                  aTargets: [3],
                  mRender: (data) => {
                    return `<a class="location-output" href=""><i class="fa fa-angle-down"></i> <span>Show</span></a><div class="hidden content">${data}</div>`;
                  },
                },
              ]
            : [],
        });
        dataTable.start();

        this.tabs.push(tab);
        this.dataTables.push(dataTable);
      }
    },
  });

  exports.Index = Index;
});
